import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, ExternalLink, Instagram, Linkedin } from "lucide-react";
import { trackCallEvent } from "@/lib/analytics";
import logo from "@/assets/logo.webp";
const Footer = () => {
  return <footer className="bg-dark text-dark-foreground">

      {/* Main Footer */}
      <div className="container py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4 text-center md:text-left">
          {/* Brand */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <img src={logo} alt="Ivana Glow Medical Spa" width={256} height={256} loading="lazy" decoding="async" className="h-20 md:h-28 w-auto invert brightness-200" />
            <p className="text-white/80 text-sm leading-relaxed">
              Step into an oasis of magnificence we devised for your new beauty center, resort or spa site. We are sure you'll love your time with Ivana.
            </p>
          </div>

          {/* Contact Info */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <h3 className="text-lg font-medium text-white">Contact Us</h3>
            <ul className="space-y-3 text-white/80 text-sm">
              <li>
                <a href="tel:+18472830204" onClick={trackCallEvent} className="flex items-center gap-2 hover:text-white transition-colors text-center">
                  <Phone className="w-4 h-4 text-white/70" />
                                                      (847) 283-0204
                </a>
              </li>
              <li>
                <a href="mailto:szymanski0501@aol.com" className="flex items-center gap-2 hover:text-white transition-colors">
                  <Mail className="w-4 h-4 text-white/70" />
                  szymanski0501@aol.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-white/70 shrink-0 mt-0.5" />
                225 E Deerpath, Lake Forest, IL
              </li>
            </ul>
            <div className="flex gap-3 justify-center md:justify-start mt-2">
              <a href="https://www.facebook.com/ivanamedspa" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/ivana_medical_spa?igsh=dXF4OXNzMHgyMG5z" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.pinterest.com/szymanski0501/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Pinterest">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0a12 12 0 0 0-4.37 23.17c-.1-.94-.2-2.4.04-3.44l1.4-5.96s-.36-.72-.36-1.78c0-1.66.97-2.9 2.17-2.9 1.02 0 1.52.77 1.52 1.7 0 1.03-.66 2.58-1 4.01-.28 1.2.6 2.17 1.78 2.17 2.13 0 3.77-2.25 3.77-5.5 0-2.87-2.06-4.88-5.01-4.88-3.41 0-5.42 2.56-5.42 5.2 0 1.03.4 2.13.89 2.73a.36.36 0 0 1 .08.34l-.33 1.36c-.05.22-.18.27-.4.16-1.5-.7-2.43-2.9-2.43-4.66 0-3.81 2.77-7.3 7.98-7.3 4.19 0 7.45 2.99 7.45 6.98 0 4.16-2.63 7.52-6.28 7.52-1.23 0-2.38-.64-2.77-1.39l-.75 2.88c-.27 1.05-1.01 2.36-1.5 3.16A12 12 0 1 0 12 0z"/></svg>
              </a>
              <a href="https://www.linkedin.com/in/ivana-medspa-szymanski-a24539131" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-white">Quick Links</h3>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/service-areas" className="hover:text-white transition-colors">Service Areas</Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-white transition-colors">FAQ</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-medium text-white">Opening Hours</h3>
            <ul className="space-y-2 text-white/80 text-sm">
              <li><span>Sunday: </span><span>9:00 am – 1:00 pm</span></li>
              <li><span>Monday: </span><span>9:00 am – 6:00 pm</span></li>
              <li><span>Tuesday: </span><span>9:00 am – 6:00 pm</span></li>
              <li><span>Wednesday: </span><span>9:00 am – 6:00 pm</span></li>
              <li><span>Thursday: </span><span>9:00 am – 6:00 pm</span></li>
              <li><span>Friday: </span><span>9:00 am – 6:00 pm</span></li>
              <li><span>Saturday: </span><span>9:00 am – 3:00 pm</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/70">
            <p>© {new Date().getFullYear()} Ivana Glow Medical Spa. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-1">
                ✓ Licensed Medical Aesthetician
              </span>
              <span className="flex items-center gap-1">
                ✓ 25+ Years Experience
              </span>
              <span className="flex items-center gap-1">
                ✓ Award Winning
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
